var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { WorkflowService } from '../../../../services/workload/workflow.service';
var StateTransitionHistoryComponent = /** @class */ (function () {
    function StateTransitionHistoryComponent(workflowService) {
        this.workflowService = workflowService;
        this.getHistorySubscription = new Subscription();
        this.viewModel = {
            transitions: [],
            areTransitionsEmpty: false,
            noActivityText: 'No Activity has been recorded'
        };
        this.requestId = Input('requestId');
    }
    StateTransitionHistoryComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.workflowService.getStateTransitionsByRequestId(this.requestId).subscribe(function (response) {
                                _this.viewModel.transitions = response.transitions;
                                _this.viewModel.areTransitionsEmpty = _this.viewModel.transitions.length === 0;
                            })];
                    case 1:
                        _a.getHistorySubscription = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StateTransitionHistoryComponent.prototype.ngOnDestroy = function () {
        this.getHistorySubscription.unsubscribe();
    };
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StateTransitionHistoryComponent.prototype, "requestId", void 0);
    StateTransitionHistoryComponent = __decorate([
        Component({
            selector: 'state-transition-history',
            template: require('./state-transition-history.component.html'),
            styles: [require('./state-transition-history.component.scss')]
        }),
        __metadata("design:paramtypes", [WorkflowService])
    ], StateTransitionHistoryComponent);
    return StateTransitionHistoryComponent;
}());
export { StateTransitionHistoryComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUtdHJhbnNpdGlvbi1oaXN0b3J5LmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0YXRlLXRyYW5zaXRpb24taGlzdG9yeS5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBcUIsTUFBTSxlQUFlLENBQUM7QUFDcEUsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLE1BQU0sQ0FBQztBQUdwQyxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFPakY7SUFPSSx5Q0FBb0MsZUFBZ0M7UUFBaEMsb0JBQWUsR0FBZixlQUFlLENBQWlCO1FBSjVELDJCQUFzQixHQUFpQixJQUFJLFlBQVksRUFBRSxDQUFDO1FBSzlELElBQUksQ0FBQyxTQUFTLEdBQUc7WUFDYixXQUFXLEVBQUUsRUFBRTtZQUNmLG1CQUFtQixFQUFFLEtBQUs7WUFDMUIsY0FBYyxFQUFFLCtCQUErQjtTQUNsRCxDQUFDO1FBQ0YsSUFBSSxDQUFDLFNBQVMsR0FBRyxLQUFLLENBQUMsV0FBVyxDQUFDLENBQUM7SUFDeEMsQ0FBQztJQUVZLGtEQUFRLEdBQXJCOzs7Ozs7O3dCQUNJLEtBQUEsSUFBSSxDQUFBO3dCQUEwQixxQkFBTSxJQUFJLENBQUMsZUFBZSxDQUFDLDhCQUE4QixDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQzdHLFVBQUEsUUFBUTtnQ0FDSixLQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsR0FBRyxRQUFRLENBQUMsV0FBVyxDQUFDO2dDQUNsRCxLQUFJLENBQUMsU0FBUyxDQUFDLG1CQUFtQixHQUFHLEtBQUksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLE1BQU0sS0FBSyxDQUFDLENBQUM7NEJBQ2pGLENBQUMsQ0FBQyxFQUFBOzt3QkFKTixHQUFLLHNCQUFzQixHQUFHLFNBSXhCLENBQUM7Ozs7O0tBQ1Y7SUFFTSxxREFBVyxHQUFsQjtRQUNJLElBQUksQ0FBQyxzQkFBc0IsQ0FBQyxXQUFXLEVBQUUsQ0FBQztJQUM5QyxDQUFDO0lBekJRO1FBQVIsS0FBSyxFQUFFOztzRUFBMEI7SUFEekIsK0JBQStCO1FBTDNDLFNBQVMsQ0FBQztZQUNQLFFBQVEsRUFBRSwwQkFBMEI7WUFDcEMsUUFBUSxFQUFFLE9BQU8sQ0FBQywyQ0FBMkMsQ0FBQztZQUM5RCxNQUFNLEVBQUUsQ0FBQyxPQUFPLENBQUMsMkNBQTJDLENBQUMsQ0FBQztTQUNqRSxDQUFDO3lDQVF1RCxlQUFlO09BUDNELCtCQUErQixDQTJCM0M7SUFBRCxzQ0FBQztDQUFBLEFBM0JELElBMkJDO1NBM0JZLCtCQUErQiJ9